import {regular} from '@fortawesome/fontawesome-svg-core/import.macro';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import './FeedbackModalAttachment.scss';

interface FeedbackModalAttachmentProps {
  file: File;
  index: number;
  onRemoveFile: (index: number) => void;
}

export const FeedbackModalAttachment: React.FC<FeedbackModalAttachmentProps> = ({ file, index, onRemoveFile }) => {
  return (
    <div key={file.name} className="feedback-modal-attachment">
      <div>
        <FontAwesomeIcon icon={regular('paperclip')} className="feedback-modal-attachment__paperclip-icon" fixedWidth />
        {file.name}
      </div>
      <FontAwesomeIcon
        icon={regular('trash-alt')}
        className="feedback-modal-attachment__trash-icon"
        onClick={() => onRemoveFile(index)}
        fixedWidth
      />
    </div>
  );
};
